export default __webpack_public_path__ + "static/media/about-team-tom-kelly.27803d9b.png";